import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const Blog = () => {
  const [activeFilter, setActiveFilter] = useState('Todos');
  
  const filters = ['Todos', 'Guía de Compra', 'Gestión Empresarial', 'Productos', 'Modelo de Negocio', 'Ahorro y Eficiencia'];
  
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-32 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="animate-on-scroll transition-all duration-700 text-center opacity-100 translate-y-0">
            <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-article-line text-4xl"></i>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Blog CX Comercializadora</h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Consejos prácticos, guías especializadas y estrategias para optimizar la gestión de suministros en tu empresa
            </p>
          </div>
        </div>
      </section>
      
      {/* Filtros */}
      <section className="py-8 bg-gray-50 sticky top-20 z-40 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap gap-3 justify-center">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-6 py-2.5 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer text-sm ${
                  activeFilter === filter
                    ? 'bg-[#2d5a8c] text-white shadow-lg hover:shadow-xl'
                    : 'bg-white text-gray-700 hover:bg-[#2d5a8c] hover:text-white border border-gray-300 hover:border-[#2d5a8c]'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>
      </section>
      
      {/* Artículos del Blog */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Artículo 1 */}
            <Link
              to="/blog/donde-comprar-articulos-oficina-puebla"
              className="animate-on-scroll transition-all duration-700 bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl hover:-translate-y-2 cursor-pointer border border-gray-100 group block opacity-100 translate-y-0"
            >
              <div className="relative overflow-hidden h-56">
                <img
                  alt="¿Dónde comprar artículos de oficina en Puebla para empresas?"
                  title="¿Dónde comprar artículos de oficina en Puebla para empresas? - CX Comercializadora"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://public.readdy.ai/ai/img_res/5866ae6e74265da094ba5953c35eaa39.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-[#2d5a8c] text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-lg">
                    Guía de Compra
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 text-xs text-gray-500 mb-4">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line text-sm"></i>
                    15 Marzo 2024
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line text-sm"></i>
                    5 min
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#1e3a5f] mb-3 line-clamp-2 group-hover:text-[#2d5a8c] transition-colors leading-tight">
                  ¿Dónde comprar artículos de oficina en Puebla para empresas?
                </h3>
                <p className="text-gray-600 mb-5 line-clamp-3 leading-relaxed text-sm">
                  Si tu empresa está en Puebla y necesita artículos de oficina con entrega rápida, facturación electrónica y precios competitivos, descubre qué debe ofrecer un proveedor especializado para optimizar tus procesos administrativos.
                </p>
                <span className="inline-flex items-center gap-2 text-[#2d5a8c] font-bold hover:gap-3 transition-all duration-300 whitespace-nowrap text-sm group-hover:text-[#1e3a5f]">
                  Leer artículo completo
                  <i className="ri-arrow-right-line text-lg"></i>
                </span>
              </div>
            </Link>
            
            {/* Artículo 2 */}
            <Link
              to="/blog/como-optimizar-compras-papeleria-empresa"
              className="animate-on-scroll transition-all duration-700 bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl hover:-translate-y-2 cursor-pointer border border-gray-100 group block opacity-100 translate-y-0"
            >
              <div className="relative overflow-hidden h-56">
                <img
                  alt="Cómo optimizar las compras de papelería en tu empresa"
                  title="Cómo optimizar las compras de papelería en tu empresa - CX Comercializadora"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://public.readdy.ai/ai/img_res/f30be2aa26ce578e4a28b39001409c9c.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-[#2d5a8c] text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-lg">
                    Gestión Empresarial
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 text-xs text-gray-500 mb-4">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line text-sm"></i>
                    10 Marzo 2024
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line text-sm"></i>
                    6 min
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#1e3a5f] mb-3 line-clamp-2 group-hover:text-[#2d5a8c] transition-colors leading-tight">
                  Cómo optimizar las compras de papelería en tu empresa
                </h3>
                <p className="text-gray-600 mb-5 line-clamp-3 leading-relaxed text-sm">
                  La compra de papelería puede generar retrasos, sobrecostos y desorden administrativo cuando no se gestiona correctamente. Descubre cómo optimizar este proceso clave para empresas medianas.
                </p>
                <span className="inline-flex items-center gap-2 text-[#2d5a8c] font-bold hover:gap-3 transition-all duration-300 whitespace-nowrap text-sm group-hover:text-[#1e3a5f]">
                  Leer artículo completo
                  <i className="ri-arrow-right-line text-lg"></i>
                </span>
              </div>
            </Link>
            
            {/* Artículo 3 */}
            <Link
              to="/blog/insumos-oficina-empresa-mediana"
              className="animate-on-scroll transition-all duration-700 bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl hover:-translate-y-2 cursor-pointer border border-gray-100 group block opacity-100 translate-y-0"
            >
              <div className="relative overflow-hidden h-56">
                <img
                  alt="Qué insumos de oficina no deben faltar en una empresa mediana"
                  title="Qué insumos de oficina no deben faltar en una empresa mediana - CX Comercializadora"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=essential%20office%20supplies%20collection%20paper%20reams%20folders%20pens%20markers%20tape%20organized%20display%20medium%20size%20business%20inventory%20stationery%20products%20professional%20workspace%20supplies%20clean%20white%20background&width=800&height=500&seq=blog-cx-puebla-03&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-[#2d5a8c] text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-lg">
                    Productos
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 text-xs text-gray-500 mb-4">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line text-sm"></i>
                    5 Marzo 2024
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line text-sm"></i>
                    5 min
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#1e3a5f] mb-3 line-clamp-2 group-hover:text-[#2d5a8c] transition-colors leading-tight">
                  Qué insumos de oficina no deben faltar en una empresa mediana
                </h3>
                <p className="text-gray-600 mb-5 line-clamp-3 leading-relaxed text-sm">
                  Mantener un inventario básico de insumos es fundamental para evitar interrupciones operativas. Conoce los productos esenciales que toda empresa mediana debe tener siempre disponibles.
                </p>
                <span className="inline-flex items-center gap-2 text-[#2d5a8c] font-bold hover:gap-3 transition-all duration-300 whitespace-nowrap text-sm group-hover:text-[#1e3a5f]">
                  Leer artículo completo
                  <i className="ri-arrow-right-line text-lg"></i>
                </span>
              </div>
            </Link>
            
            {/* Artículo 4 */}
            <Link
              to="/blog/ventajas-proveedor-b2b-insumos-puebla"
              className="animate-on-scroll transition-all duration-700 bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl hover:-translate-y-2 cursor-pointer border border-gray-100 group block opacity-100 translate-y-0"
            >
              <div className="relative overflow-hidden h-56">
                <img
                  alt="Ventajas de contratar un proveedor B2B de insumos empresariales en Puebla"
                  title="Ventajas de contratar un proveedor B2B de insumos empresariales en Puebla - CX Comercializadora"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=business%20to%20business%20B2B%20partnership%20handshake%20professional%20meeting%20office%20supplies%20delivery%20truck%20corporate%20clients%20business%20relationship%20modern%20office%20environment%20professional%20service%20team&width=800&height=500&seq=blog-cx-puebla-04&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-[#2d5a8c] text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-lg">
                    Modelo de Negocio
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 text-xs text-gray-500 mb-4">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line text-sm"></i>
                    28 Febrero 2024
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line text-sm"></i>
                    6 min
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#1e3a5f] mb-3 line-clamp-2 group-hover:text-[#2d5a8c] transition-colors leading-tight">
                  Ventajas de contratar un proveedor B2B de insumos empresariales en Puebla
                </h3>
                <p className="text-gray-600 mb-5 line-clamp-3 leading-relaxed text-sm">
                  El modelo B2B permite a las empresas trabajar con proveedores que entienden sus procesos internos y necesidades específicas. Descubre las ventajas de este modelo de negocio.
                </p>
                <span className="inline-flex items-center gap-2 text-[#2d5a8c] font-bold hover:gap-3 transition-all duration-300 whitespace-nowrap text-sm group-hover:text-[#1e3a5f]">
                  Leer artículo completo
                  <i className="ri-arrow-right-line text-lg"></i>
                </span>
              </div>
            </Link>
            
            {/* Artículo 5 */}
            <Link
              to="/blog/reducir-costos-insumos-oficina-calidad"
              className="animate-on-scroll transition-all duration-700 bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl hover:-translate-y-2 cursor-pointer border border-gray-100 group block opacity-100 translate-y-0"
            >
              <div className="relative overflow-hidden h-56">
                <img
                  alt="Cómo reducir costos en insumos de oficina sin sacrificar calidad"
                  title="Cómo reducir costos en insumos de oficina sin sacrificar calidad - CX Comercializadora"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  src="https://readdy.ai/api/search-image?query=cost%20reduction%20strategy%20office%20supplies%20budget%20optimization%20calculator%20spreadsheet%20quality%20products%20balance%20scale%20savings%20concept%20professional%20business%20planning%20modern%20workspace&width=800&height=500&seq=blog-cx-puebla-05&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-[#2d5a8c] text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-lg">
                    Ahorro y Eficiencia
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 text-xs text-gray-500 mb-4">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line text-sm"></i>
                    20 Febrero 2024
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line text-sm"></i>
                    7 min
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#1e3a5f] mb-3 line-clamp-2 group-hover:text-[#2d5a8c] transition-colors leading-tight">
                  Cómo reducir costos en insumos de oficina sin sacrificar calidad
                </h3>
                <p className="text-gray-600 mb-5 line-clamp-3 leading-relaxed text-sm">
                  Reducir gastos no significa comprometer la calidad de los productos. Una estrategia adecuada permite optimizar recursos sin afectar la operación de tu empresa.
                </p>
                <span className="inline-flex items-center gap-2 text-[#2d5a8c] font-bold hover:gap-3 transition-all duration-300 whitespace-nowrap text-sm group-hover:text-[#1e3a5f]">
                  Leer artículo completo
                  <i className="ri-arrow-right-line text-lg"></i>
                </span>
              </div>
            </Link>
          </div>
        </div>
      </section>
      
      {/* CTA Asesoría */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="animate-on-scroll transition-all duration-700 bg-gradient-to-br from-[#1e3a5f] via-[#2d5a8c] to-[#1e3a5f] rounded-2xl overflow-hidden shadow-2xl opacity-100 translate-y-0">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="p-12 flex flex-col justify-center text-white">
                <span className="inline-block bg-white/20 text-white px-4 py-1.5 rounded-full text-xs font-bold mb-4 w-fit">
                  Destacado
                </span>
                <h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight">
                  ¿Necesitas asesoría personalizada para tu empresa?
                </h2>
                <p className="text-white/90 mb-6 leading-relaxed text-lg">
                  Nuestro equipo de expertos puede ayudarte a optimizar tus compras de insumos, reducir costos y mejorar la eficiencia operativa de tu empresa.
                </p>
                <Link
                  to="/contacto"
                  className="inline-flex items-center gap-2 bg-white text-[#1e3a5f] px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl w-fit cursor-pointer whitespace-nowrap"
                >
                  Solicitar asesoría gratuita
                  <i className="ri-arrow-right-line text-xl"></i>
                </Link>
              </div>
              <div className="relative h-80 md:h-auto">
                <img
                  alt="Asesoría empresarial"
                  className="w-full h-full object-cover object-top"
                  src="https://public.readdy.ai/ai/img_res/49a2eb0c3fb69b200a04e059939e8ec8.jpg"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Síguenos en Facebook */}
      <section className="py-20 bg-gradient-to-br from-[#1e3a5f] via-[#2d5a8c] to-[#1e3a5f] text-white">
        <div className="max-w-4xl mx-auto px-6 text-center animate-on-scroll transition-all duration-700 opacity-100 translate-y-0">
          <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-facebook-fill text-4xl"></i>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Síguenos en Facebook</h2>
          <p className="text-xl text-white/90 mb-4 leading-relaxed">
            Únete a nuestra comunidad y mantente al día con las últimas ofertas, novedades de productos y consejos exclusivos para tu empresa.
          </p>
          <p className="text-white/70 mb-10 text-base">Miles de empresas en Puebla ya nos siguen. ¡No te quedes fuera!</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://www.facebook.com/CXComercializadoraPuebla?locale=es_LA"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-white text-[#1e3a5f] px-10 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap text-base hover:scale-105 transform"
            >
              <i className="ri-facebook-fill text-2xl"></i>
              Seguir en Facebook
            </a>
            <a
              href="https://wa.me/+522228121142"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-white/10 border-2 border-white/40 text-white px-10 py-4 rounded-lg font-bold hover:bg-white/20 transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap text-base hover:scale-105 transform"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Contactar por WhatsApp
            </a>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Blog;